import {
  ChangeDetectorRef,
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { Lookup } from "src/app/models/lookup.model";
import {
    MappingGeofencedZoneGroup,
    ZoneLookup,
} from "src/app/models/mappingGeofencedZoneGroup.model";
import {
    MappingGroupZonesFilter,
    ZoneData,
} from "src/app/models/mappingGroup.model";
import { RecordDto } from "src/app/models/recordDto.model";
import { CommonService } from "src/app/services/common.service";
import { MappingGeofencedZoneGroupService } from "src/app/services/mapping-geofenced-zone-group.service";
import { MappingGroupService } from "src/app/services/mapping-group.service";
import { ToastService } from "src/app/services/toast.service";
import { GoogleMapsComponent } from "../../common-components/google-maps/google-maps.component";
import { MatDialog } from "@angular/material/dialog";
import { DeleteDialog } from "src/app/shared/delete-dialog/delete-dialog.component";
import { HeaderFilteringBaseComponent } from "src/app/shared/header-filtering-base/header-filtering-base.component";
import nameOf from "src/app/shared/form/nameOf.helper";
import { ZoneDialogComponent } from "src/app/modals/zone-dialog/zone-dialog.component";

import { trackById } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-zones",
    templateUrl: "./zones.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./zones.component.scss"],
})
export class ZonesComponent
    extends HeaderFilteringBaseComponent
    implements OnInit, AfterViewInit
{
    @ViewChild("googleMapRef") googleMapRef: GoogleMapsComponent;
    nodes: RecordDto[] = [];
    latLongRes: ZoneData[] = [];
    mappingGroupsList: Lookup[];
    selectedGroup: Lookup;
    zonesList: ZoneLookup[];
    zoneData: ZoneLookup;
    zoneLatLng: ZoneData[] = [];
    showMap = false;
    isPolygonEditable = false;
    isPolygonNameEditable = true;
    loading = false;

    constructor(
        private mappingGroupService: MappingGroupService,
        protected commonService: CommonService,
        private mappingGeofencedZoneGroupService: MappingGeofencedZoneGroupService,
        private toastService: ToastService,
        protected dialog: MatDialog,
        private cdRef: ChangeDetectorRef,
    ) {
        super(commonService);
    }

    ngOnInit(): void {
        super.ngOnInit(); // listening to header events
    }

    ngAfterViewInit() {
        this.commonService.nodesUpdated.next(true);
    }

    getOrgMappingGroups() {
        const payload: MappingGroupZonesFilter = {
            organizationLevelId: this.selectedOrg?.id,
        };
        this.mappingGroupService
            .getAll(JSON.stringify(payload))
            .subscribe((response) => {
                this.mappingGroupsList = response;
                this.selectedGroup = null;
                this.zonesList = null;
                if (response.length > 0) {
                    this.setGroup(response[0]);
                } else {
                    this.googleMapRef.updateCustomList(0);
                }
            });
    }

    setGroup(group: Lookup) {
        this.selectedGroup = group;
        const payload = {
            organizationLevelId: this.selectedOrg?.id,
            mappingGroupId: this.selectedGroup.id,
        };
        this.mappingGeofencedZoneGroupService
            .getAll(JSON.stringify(payload))
            .subscribe((response) => {
                this.zonesList = response.map((data) => ({
                    ...data,
                    isSelected: true,
                    isDisplayOptions: false,
                }));
                this.updateZones(true);
            });
    }

    setZone(response: ZoneLookup, index: number) {
        if (!response) {
            return;
        }
        const latLng = response.zoneBoundary;
        const latLngArray = latLng
            .substring(latLng.indexOf("((") + 1, latLng.indexOf("))"))
            .replace("(", "")
            .split(", ");
        const zoneLatLng: ZoneData[] = [];
        latLngArray.forEach((res) => {
            const val = res.split(" ");
            if (val.length === 2) {
                zoneLatLng.push({ lng: Number(val[0]), lat: Number(val[1]) });
            }
        });
        this.googleMapRef.displayZone(zoneLatLng, index, response.name);
    }

    updateZones(isZoneUpdated: boolean = false) {
        setTimeout(() => {
            this.googleMapRef.updateCustomList(this.zonesList.length);
            this.zonesList.forEach((data, i) => {
                if (data.isSelected && isZoneUpdated) {
                    this.subscriptions.push(
                        this.mappingGeofencedZoneGroupService
                            .getById(data.id)
                            .subscribe((res) => {
                                this.zonesList[i] = { ...data, ...res };
                                this.setZone(res, i);
                            }),
                    );
                } else if (data.isSelected) {
                    this.setZone(data, i);
                }
            });
            this.loading = false;
        });
    }

    loadComponentData(): void {
        this.getOrgMappingGroups();
    }

    openLatLong(response) {
        this.latLongRes = JSON.parse(response.value);
        this.latLongRes.push(this.latLongRes[0]);
        if (!response.isNew) {
            this.isPolygonEditable = true;
            this.zoneData = this.zonesList[response.updateIndex];
        } else {
            this.isPolygonEditable = false;
            this.isPolygonNameEditable = false;
            this.openZoneNameDialog();
        }
    }

    hidePopup(closeCreatedRef = true) {
        this.latLongRes = [];
        this.isPolygonEditable = false;
        this.isPolygonNameEditable = false;
        if (closeCreatedRef) {
            this.googleMapRef.resetCreatedZone();
        }
    }

    showNamePopup(currZone: ZoneLookup) {
        this.zoneData = currZone;
        this.isPolygonNameEditable = true;
        this.openZoneNameDialog();
    }

    openZoneNameDialog() {
        const payload = new MappingGeofencedZoneGroup();
        if (!this.isPolygonNameEditable) {
            payload.mappingGroupId = String(this.selectedGroup.id);
            payload.organizationLevelId = this.selectedOrg?.id;
            let zoneBoundaryText = "POLYGON ((";
            this.latLongRes.forEach((res, i) => {
                zoneBoundaryText += `${res.lng} ${res.lat}`;
                if (i !== this.latLongRes.length - 1) {
                    zoneBoundaryText += ", ";
                }
            });
            zoneBoundaryText += "))";
            payload.zoneBoundary = zoneBoundaryText;
        } else {
            payload.id = String(this.zoneData.id);
        }

        const dialogRef = this.dialog.open(ZoneDialogComponent, {
            data: payload,
            width: "300px",
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result && !this.isPolygonNameEditable) {
                this.setGroup(this.selectedGroup);
            } else if (result) {
                this.updateZones(true);
            }
            this.googleMapRef.resetCreatedZone();
            this.hidePopup(false);
        });
    }

    openZoneDeletePopup(currZone: ZoneLookup) {
        this.zoneData = currZone;
        const dialogRef = this.dialog.open(DeleteDialog, {
            data: {
                id: currZone.id,
                formDeletes: true,
                title: currZone.name,
                service: this.mappingGeofencedZoneGroupService,
            },
            width: "440px",
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                const index = this.zonesList.findIndex(
                    (data) => data.id === this.zoneData.id,
                );
                if (index !== -1) {
                    this.zonesList.splice(index, 1);
                    this.googleMapRef.resetZone(index);
                    this.googleMapRef.updateCustomList(this.zonesList.length);
                }
                this.updateZones();
            }
        });
    }

    polygonSubmit() {
        let zoneBoundaryText = "POLYGON ((";
        this.latLongRes.forEach((res, i) => {
            zoneBoundaryText += `${res.lng} ${res.lat}`;
            if (i !== this.latLongRes.length - 1) {
                zoneBoundaryText += ", ";
            }
        });
        zoneBoundaryText += "))";
        const payload = {};
        payload[nameOf<MappingGeofencedZoneGroup>((x) => x.zoneBoundary)] =
            zoneBoundaryText;
        this.updatePolygon(this.zoneData.id, payload);
    }

    updatePolygon(id: string | number, payload) {
        this.loading = true;
        this.mappingGeofencedZoneGroupService.patch(id, payload).subscribe(
            () => {
                const updatedZone = this.zonesList.find(
                    (zone) => zone.id === id,
                );
                updatedZone.zoneBoundary = payload.zoneBoundary;
                this.updateZones();
                this.hidePopup(false);
            },
            (error) => {
                this.loading = false;
                this.hidePopup(false);
                this.toastService.displayErrorMessage(
                    "Error updating zone",
                    true,
                );
            },
        );
    }

    polygonHover(event) {
        const { index, show } = event;
        this.zonesList[index].isFocused = show;
        this.cdRef.detectChanges();
    }

    highlightPolygon(zone: ZoneLookup, show: boolean) {
        const currIndex = this.zonesList.findIndex(
            (data) => data.id === zone.id,
        );
        if (zone.isSelected && currIndex !== -1) {
            zone.isFocused = show;
            this.googleMapRef.focusOnPolygon(currIndex, show);
        } else {
            zone.isFocused = false;
        }
    }


    get hasOrgFilter() {
        return true;
    }

    get hasParameterFilter() {
        return true;
    }

    showInfoWindow(zone: ZoneLookup, show = true) {
        const currIndex = this.zonesList.findIndex(
            (data) => data.id === zone.id,
        );
        if (zone.isSelected && currIndex !== -1) {
            this.googleMapRef.showInfoWindow(currIndex, show);
        }
    }

    public trackById = trackById;
}
